import styled from "styled-components";
import { CSSProperties } from "react";
import _ from "lodash";

interface INotificationIndicatorProps {
    bottom?: CSSProperties['bottom'];
    right?: CSSProperties['right'];
    top?: CSSProperties['top'];
}

export const NotificationIndicatorStyled = styled.div<INotificationIndicatorProps>`
    position: absolute;
    height: 6px;
    width: 6px;
    border-radius: 4px;
    background: var(--color-label-negative);
    
    ${({ bottom }) => _.isUndefined(bottom) ? '' : `bottom: ${bottom};`}
    ${({ right }) => _.isUndefined(right) ? '' : `right: ${right};`}
    ${({ top }) => _.isUndefined(top) ? '' : `top: ${top};`}
    
    &.sm {
        height: 4px;
        width: 4px;
    }
`;
